// Lucky Flamingo audio audition registry.
// Add each received file here with its metadata. `category` is one of:
//   'base'  -> Base Loops
//   'bonus' -> Bonus Loops
//   'sfx'   -> Effects
// Music beds ('base'/'bonus') should default 25-35% lower gain than SFX.
import velvetSteps from './06 - Velvet Steps.ogg';

export const FLAMINGO_TRACKS = [
  {
    id: 'velvet-steps',
    title: 'Velvet Steps',
    file: '06 - Velvet Steps.ogg',
    pack: 'Velvet Lounge Vol. 2 (assumed)',
    category: 'base',
    format: 'Ogg Vorbis · 48kHz · Stereo · 160kbps',
    duration: '2:32',
    license: 'pending',
    source: 'pending',
    contentId: 'pending',
    src: velvetSteps,
  },
];

export const CATEGORY_LABELS = {
  base: 'Base Loops',
  bonus: 'Bonus Loops',
  sfx: 'Effects (SFX)',
};

// Default gains: music 25-35% lower than effects.
export const DEFAULT_GAIN = { base: 0.62, bonus: 0.62, sfx: 0.9 };
